import CircularProgress from '@mui/material/CircularProgress'
import React from 'react'
import ErrorMessage from '../error/ErrorMessage'
import css from './Loader.css'

type LoaderProps = {
  loading: boolean
  error?: Record<string, any>
  refetch?: (...props: any) => any
  hideSpinner?: boolean
  children: any
}

const Loader = ({ loading, error, refetch, children, hideSpinner }: LoaderProps) => {
  if (loading) {
    if (hideSpinner) {
      return null
    }

    return (
      <div className={css.component}>
        <CircularProgress />
      </div>
    )
  }
  if (error) {
    return <ErrorMessage message={error.message} refetch={refetch} />
  }
  return children
}

export default Loader
